import { CONTACT_PERSON_TYPE_TRANSLATION } from "@/constants/contact.constants";
import { ContactAddressMessages } from "@/messages/contacts/address-section.messages";
import { ContactFormPageMessages } from "@/messages/contacts/contact-form-page.messages";
import { ContactPersonTypeMessages } from "@/messages/contacts/contact-person-type.messages";
import { ContactPhoneSectionMessages } from "@/messages/contacts/phone-section.messages";
import { PersonType } from "@/types/document.types";
import { SelectData, TabItem } from "@/types/form.types";

import { ContactTabs } from "./types";

export const TABS_ITEMS = (
  messages: ContactFormPageMessages,
  isEditing: boolean
): TabItem<ContactTabs>[] => {
  const { personalDetailsSection, chatSection } = messages;
  const tabs = [{ value: "personalDetailsTab", label: personalDetailsSection }];

  if (isEditing) tabs.push({ value: "chatTab", label: chatSection });

  return tabs as TabItem<ContactTabs>[];
};

export const ADDRESSES_TABLE_COLUMNS = (messages: ContactAddressMessages) => {
  return [
    messages.addressNameColumn,
    messages.addressColumn,
    messages.addressNumberColumn,
    messages.addressComplColumn,
    messages.addressDistrictColumn,
    messages.addressCityColumn,
    messages.addressStateColumn,
    messages.addressStateUfColumn,
    messages.addressZipCodeColumn,
    messages.addressCountryColumn,
    messages.optionsColumn,
  ];
};

export const PERSON_TYPE_OPTIONS = (
  messages: ContactPersonTypeMessages
): SelectData<PersonType>[] => {
  const labels = CONTACT_PERSON_TYPE_TRANSLATION(messages);

  return [
    { value: PersonType.Individual, label: labels[PersonType.Individual] },
    { value: PersonType.LegalEntity, label: labels[PersonType.LegalEntity] },
  ];
};

export const DDI_OPTIONS = (messages: ContactPhoneSectionMessages): SelectData<string>[] => [
  { value: "55", label: `55 - ${messages.ddiBrazilOption}` },
];
export const DDI_OPTIONS_PHONE2 = (messages: ContactPhoneSectionMessages): SelectData<string>[] => [
  { value: "55", label: `55 - ${messages.ddiBrazilOption}` },
  { value: "", label: messages.noDDI },
];

export const COUNTRY_OPTIONS = (messages: ContactAddressMessages): SelectData<string>[] => [
  { value: "BRASIL", label: messages.addressBrazilOption },
];
